export default "__VITE_ASSET__CjFD3KJ9__"